export default __webpack_public_path__ + "left-indentation-option.png";